import React from "react";

const WHATSAPP_NUMBER = "917249797972";
const MESSAGE = encodeURIComponent(
  "Hi HerbKranti, I'd like to know more about your Sea Buckthorn Pure Pulp."
);

export const FloatingWhatsApp = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${MESSAGE}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="hk-whatsapp hk-pulse group"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="26"
        height="26"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 0 5.37 0 12a11.94 11.94 0 0 0 1.64 6.06L0 24l6.12-1.6A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52ZM12 21.82a9.79 9.79 0 0 1-5-1.37l-.36-.22-3.63.95.97-3.53-.24-.37A9.79 9.79 0 0 1 2.18 12C2.18 6.6 6.6 2.18 12 2.18c2.63 0 5.1 1.02 6.96 2.88a9.75 9.75 0 0 1 2.86 6.94c0 5.4-4.42 9.82-9.82 9.82Zm5.4-7.35c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15-.2.3-.76.96-.93 1.16-.17.2-.34.22-.63.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.34.44-.5.15-.17.2-.29.3-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.6-.9-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.19 0-.5.07-.76.37-.26.3-1 1-1 2.44s1.03 2.83 1.17 3.03c.15.2 2.03 3.1 4.92 4.35.69.3 1.23.48 1.65.62.69.22 1.31.19 1.8.12.55-.08 1.75-.72 2-1.42.25-.7.25-1.31.17-1.42-.07-.11-.27-.17-.57-.32Z" />
      </svg>
    </a>
  );
};

export default FloatingWhatsApp;
